/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AppsImport } from './routes/apps'
import { Route as AccountImport } from './routes/account'
import { Route as ProtectedRouteImport } from './routes/_protected/route'
import { Route as IndexImport } from './routes/index'
import { Route as ContactIndexImport } from './routes/contact/index'
import { Route as SubscriptionsSubscriptionNoImport } from './routes/subscriptions/$subscriptionNo'
import { Route as PaymentPlansPaymentPlanIdImport } from './routes/payment-plans/$paymentPlanId'
import { Route as OrdersOrderNoImport } from './routes/orders/$orderNo'
import { Route as AuthVerifyEmailChangeImport } from './routes/auth/verify-email-change'
import { Route as AuthUpdatePasswordImport } from './routes/auth/update-password'
import { Route as AuthSsoImport } from './routes/auth/sso'
import { Route as AuthResetPasswordImport } from './routes/auth/reset-password'
import { Route as AuthMagicLinkImport } from './routes/auth/magic-link'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AuthForgotPasswordImport } from './routes/auth/forgot-password'
import { Route as AuthCancelEmailChangeImport } from './routes/auth/cancel-email-change'
import { Route as AuthCallbackImport } from './routes/auth/callback'
import { Route as ProtectedMediaIndexImport } from './routes/_protected/media/index'
import { Route as ProtectedCommunityHubIndexImport } from './routes/_protected/community-hub/index'
import { Route as ProtectedBillingIndexImport } from './routes/_protected/billing/index'
import { Route as ProtectedCommunityHubSpacesIdRouteImport } from './routes/_protected/community-hub/spaces/$id/route'
import { Route as ProtectedCommunityHubSpacesIdIndexImport } from './routes/_protected/community-hub/spaces/$id/index'
import { Route as ProtectedCommunityHubSpacesIdCommunityImport } from './routes/_protected/community-hub/spaces/$id/community'
import { Route as ProtectedCommunityHubSpacesIdModulesIndexImport } from './routes/_protected/community-hub/spaces/$id/modules/index'
import { Route as ProtectedCommunityHubSpacesIdLessonIndexImport } from './routes/_protected/community-hub/spaces/$id/lesson/index'
import { Route as ProtectedCommunityHubSpacesIdPostsPostIdImport } from './routes/_protected/community-hub/spaces/$id/posts/$postId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdIndexImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/index'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/index'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
import { Route as ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdImport } from './routes/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'

// Create/Update Routes

const AppsRoute = AppsImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => rootRoute,
} as any)

const AccountRoute = AccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedRouteRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ContactIndexRoute = ContactIndexImport.update({
  id: '/contact/',
  path: '/contact/',
  getParentRoute: () => rootRoute,
} as any)

const SubscriptionsSubscriptionNoRoute =
  SubscriptionsSubscriptionNoImport.update({
    id: '/subscriptions/$subscriptionNo',
    path: '/subscriptions/$subscriptionNo',
    getParentRoute: () => rootRoute,
  } as any)

const PaymentPlansPaymentPlanIdRoute = PaymentPlansPaymentPlanIdImport.update({
  id: '/payment-plans/$paymentPlanId',
  path: '/payment-plans/$paymentPlanId',
  getParentRoute: () => rootRoute,
} as any)

const OrdersOrderNoRoute = OrdersOrderNoImport.update({
  id: '/orders/$orderNo',
  path: '/orders/$orderNo',
  getParentRoute: () => rootRoute,
} as any)

const AuthVerifyEmailChangeRoute = AuthVerifyEmailChangeImport.update({
  id: '/auth/verify-email-change',
  path: '/auth/verify-email-change',
  getParentRoute: () => rootRoute,
} as any)

const AuthUpdatePasswordRoute = AuthUpdatePasswordImport.update({
  id: '/auth/update-password',
  path: '/auth/update-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthSsoRoute = AuthSsoImport.update({
  id: '/auth/sso',
  path: '/auth/sso',
  getParentRoute: () => rootRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthMagicLinkRoute = AuthMagicLinkImport.update({
  id: '/auth/magic-link',
  path: '/auth/magic-link',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthForgotPasswordRoute = AuthForgotPasswordImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthCancelEmailChangeRoute = AuthCancelEmailChangeImport.update({
  id: '/auth/cancel-email-change',
  path: '/auth/cancel-email-change',
  getParentRoute: () => rootRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedMediaIndexRoute = ProtectedMediaIndexImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedCommunityHubIndexRoute = ProtectedCommunityHubIndexImport.update(
  {
    id: '/community-hub/',
    path: '/community-hub/',
    getParentRoute: () => ProtectedRouteRoute,
  } as any,
)

const ProtectedBillingIndexRoute = ProtectedBillingIndexImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedCommunityHubSpacesIdRouteRoute =
  ProtectedCommunityHubSpacesIdRouteImport.update({
    id: '/community-hub/spaces/$id',
    path: '/community-hub/spaces/$id',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdIndexRoute =
  ProtectedCommunityHubSpacesIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdCommunityRoute =
  ProtectedCommunityHubSpacesIdCommunityImport.update({
    id: '/community',
    path: '/community',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdModulesIndexRoute =
  ProtectedCommunityHubSpacesIdModulesIndexImport.update({
    id: '/modules/',
    path: '/modules/',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdLessonIndexRoute =
  ProtectedCommunityHubSpacesIdLessonIndexImport.update({
    id: '/lesson/',
    path: '/lesson/',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdPostsPostIdRoute =
  ProtectedCommunityHubSpacesIdPostsPostIdImport.update({
    id: '/posts/$postId',
    path: '/posts/$postId',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdIndexImport.update({
    id: '/modules/$moduleId/',
    path: '/modules/$moduleId/',
    getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
  } as any)

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/',
      path: '/modules/$moduleId/lessons/$lessonId/',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/video/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/video/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/text/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/text/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/results/$attemptId',
      path: '/modules/$moduleId/lessons/$lessonId/results/$attemptId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/quiz/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/quiz/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/pdf/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/pdf/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/form/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/form/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/event/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/event/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

const ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute =
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdImport.update(
    {
      id: '/modules/$moduleId/lessons/$lessonId/embed/$contentId',
      path: '/modules/$moduleId/lessons/$lessonId/embed/$contentId',
      getParentRoute: () => ProtectedCommunityHubSpacesIdRouteRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRoute
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountImport
      parentRoute: typeof rootRoute
    }
    '/apps': {
      id: '/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AppsImport
      parentRoute: typeof rootRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/auth/cancel-email-change': {
      id: '/auth/cancel-email-change'
      path: '/auth/cancel-email-change'
      fullPath: '/auth/cancel-email-change'
      preLoaderRoute: typeof AuthCancelEmailChangeImport
      parentRoute: typeof rootRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/auth/magic-link': {
      id: '/auth/magic-link'
      path: '/auth/magic-link'
      fullPath: '/auth/magic-link'
      preLoaderRoute: typeof AuthMagicLinkImport
      parentRoute: typeof rootRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/sso': {
      id: '/auth/sso'
      path: '/auth/sso'
      fullPath: '/auth/sso'
      preLoaderRoute: typeof AuthSsoImport
      parentRoute: typeof rootRoute
    }
    '/auth/update-password': {
      id: '/auth/update-password'
      path: '/auth/update-password'
      fullPath: '/auth/update-password'
      preLoaderRoute: typeof AuthUpdatePasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/verify-email-change': {
      id: '/auth/verify-email-change'
      path: '/auth/verify-email-change'
      fullPath: '/auth/verify-email-change'
      preLoaderRoute: typeof AuthVerifyEmailChangeImport
      parentRoute: typeof rootRoute
    }
    '/orders/$orderNo': {
      id: '/orders/$orderNo'
      path: '/orders/$orderNo'
      fullPath: '/orders/$orderNo'
      preLoaderRoute: typeof OrdersOrderNoImport
      parentRoute: typeof rootRoute
    }
    '/payment-plans/$paymentPlanId': {
      id: '/payment-plans/$paymentPlanId'
      path: '/payment-plans/$paymentPlanId'
      fullPath: '/payment-plans/$paymentPlanId'
      preLoaderRoute: typeof PaymentPlansPaymentPlanIdImport
      parentRoute: typeof rootRoute
    }
    '/subscriptions/$subscriptionNo': {
      id: '/subscriptions/$subscriptionNo'
      path: '/subscriptions/$subscriptionNo'
      fullPath: '/subscriptions/$subscriptionNo'
      preLoaderRoute: typeof SubscriptionsSubscriptionNoImport
      parentRoute: typeof rootRoute
    }
    '/contact/': {
      id: '/contact/'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactIndexImport
      parentRoute: typeof rootRoute
    }
    '/_protected/billing/': {
      id: '/_protected/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof ProtectedBillingIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/community-hub/': {
      id: '/_protected/community-hub/'
      path: '/community-hub'
      fullPath: '/community-hub'
      preLoaderRoute: typeof ProtectedCommunityHubIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/media/': {
      id: '/_protected/media/'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof ProtectedMediaIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/community-hub/spaces/$id': {
      id: '/_protected/community-hub/spaces/$id'
      path: '/community-hub/spaces/$id'
      fullPath: '/community-hub/spaces/$id'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/community-hub/spaces/$id/community': {
      id: '/_protected/community-hub/spaces/$id/community'
      path: '/community'
      fullPath: '/community-hub/spaces/$id/community'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdCommunityImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/': {
      id: '/_protected/community-hub/spaces/$id/'
      path: '/'
      fullPath: '/community-hub/spaces/$id/'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdIndexImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/posts/$postId': {
      id: '/_protected/community-hub/spaces/$id/posts/$postId'
      path: '/posts/$postId'
      fullPath: '/community-hub/spaces/$id/posts/$postId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdPostsPostIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/lesson/': {
      id: '/_protected/community-hub/spaces/$id/lesson/'
      path: '/lesson'
      fullPath: '/community-hub/spaces/$id/lesson'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdLessonIndexImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/': {
      id: '/_protected/community-hub/spaces/$id/modules/'
      path: '/modules'
      fullPath: '/community-hub/spaces/$id/modules'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesIndexImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/'
      path: '/modules/$moduleId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdIndexImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/'
      path: '/modules/$moduleId/lessons/$lessonId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/embed/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/event/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/form/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
      path: '/modules/$moduleId/lessons/$lessonId/results/$attemptId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/text/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
    '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId': {
      id: '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
      path: '/modules/$moduleId/lessons/$lessonId/video/$contentId'
      fullPath: '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
      preLoaderRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdImport
      parentRoute: typeof ProtectedCommunityHubSpacesIdRouteImport
    }
  }
}

// Create and export the route tree

interface ProtectedCommunityHubSpacesIdRouteRouteChildren {
  ProtectedCommunityHubSpacesIdCommunityRoute: typeof ProtectedCommunityHubSpacesIdCommunityRoute
  ProtectedCommunityHubSpacesIdIndexRoute: typeof ProtectedCommunityHubSpacesIdIndexRoute
  ProtectedCommunityHubSpacesIdPostsPostIdRoute: typeof ProtectedCommunityHubSpacesIdPostsPostIdRoute
  ProtectedCommunityHubSpacesIdLessonIndexRoute: typeof ProtectedCommunityHubSpacesIdLessonIndexRoute
  ProtectedCommunityHubSpacesIdModulesIndexRoute: typeof ProtectedCommunityHubSpacesIdModulesIndexRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute
  ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute: typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute
}

const ProtectedCommunityHubSpacesIdRouteRouteChildren: ProtectedCommunityHubSpacesIdRouteRouteChildren =
  {
    ProtectedCommunityHubSpacesIdCommunityRoute:
      ProtectedCommunityHubSpacesIdCommunityRoute,
    ProtectedCommunityHubSpacesIdIndexRoute:
      ProtectedCommunityHubSpacesIdIndexRoute,
    ProtectedCommunityHubSpacesIdPostsPostIdRoute:
      ProtectedCommunityHubSpacesIdPostsPostIdRoute,
    ProtectedCommunityHubSpacesIdLessonIndexRoute:
      ProtectedCommunityHubSpacesIdLessonIndexRoute,
    ProtectedCommunityHubSpacesIdModulesIndexRoute:
      ProtectedCommunityHubSpacesIdModulesIndexRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute,
    ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute:
      ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute,
  }

const ProtectedCommunityHubSpacesIdRouteRouteWithChildren =
  ProtectedCommunityHubSpacesIdRouteRoute._addFileChildren(
    ProtectedCommunityHubSpacesIdRouteRouteChildren,
  )

interface ProtectedRouteRouteChildren {
  ProtectedBillingIndexRoute: typeof ProtectedBillingIndexRoute
  ProtectedCommunityHubIndexRoute: typeof ProtectedCommunityHubIndexRoute
  ProtectedMediaIndexRoute: typeof ProtectedMediaIndexRoute
  ProtectedCommunityHubSpacesIdRouteRoute: typeof ProtectedCommunityHubSpacesIdRouteRouteWithChildren
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedBillingIndexRoute: ProtectedBillingIndexRoute,
  ProtectedCommunityHubIndexRoute: ProtectedCommunityHubIndexRoute,
  ProtectedMediaIndexRoute: ProtectedMediaIndexRoute,
  ProtectedCommunityHubSpacesIdRouteRoute:
    ProtectedCommunityHubSpacesIdRouteRouteWithChildren,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof ProtectedRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/apps': typeof AppsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/cancel-email-change': typeof AuthCancelEmailChangeRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/magic-link': typeof AuthMagicLinkRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sso': typeof AuthSsoRoute
  '/auth/update-password': typeof AuthUpdatePasswordRoute
  '/auth/verify-email-change': typeof AuthVerifyEmailChangeRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/payment-plans/$paymentPlanId': typeof PaymentPlansPaymentPlanIdRoute
  '/subscriptions/$subscriptionNo': typeof SubscriptionsSubscriptionNoRoute
  '/contact': typeof ContactIndexRoute
  '/billing': typeof ProtectedBillingIndexRoute
  '/community-hub': typeof ProtectedCommunityHubIndexRoute
  '/media': typeof ProtectedMediaIndexRoute
  '/community-hub/spaces/$id': typeof ProtectedCommunityHubSpacesIdRouteRouteWithChildren
  '/community-hub/spaces/$id/community': typeof ProtectedCommunityHubSpacesIdCommunityRoute
  '/community-hub/spaces/$id/': typeof ProtectedCommunityHubSpacesIdIndexRoute
  '/community-hub/spaces/$id/posts/$postId': typeof ProtectedCommunityHubSpacesIdPostsPostIdRoute
  '/community-hub/spaces/$id/lesson': typeof ProtectedCommunityHubSpacesIdLessonIndexRoute
  '/community-hub/spaces/$id/modules': typeof ProtectedCommunityHubSpacesIdModulesIndexRoute
  '/community-hub/spaces/$id/modules/$moduleId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof ProtectedRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/apps': typeof AppsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/cancel-email-change': typeof AuthCancelEmailChangeRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/magic-link': typeof AuthMagicLinkRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sso': typeof AuthSsoRoute
  '/auth/update-password': typeof AuthUpdatePasswordRoute
  '/auth/verify-email-change': typeof AuthVerifyEmailChangeRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/payment-plans/$paymentPlanId': typeof PaymentPlansPaymentPlanIdRoute
  '/subscriptions/$subscriptionNo': typeof SubscriptionsSubscriptionNoRoute
  '/contact': typeof ContactIndexRoute
  '/billing': typeof ProtectedBillingIndexRoute
  '/community-hub': typeof ProtectedCommunityHubIndexRoute
  '/media': typeof ProtectedMediaIndexRoute
  '/community-hub/spaces/$id/community': typeof ProtectedCommunityHubSpacesIdCommunityRoute
  '/community-hub/spaces/$id': typeof ProtectedCommunityHubSpacesIdIndexRoute
  '/community-hub/spaces/$id/posts/$postId': typeof ProtectedCommunityHubSpacesIdPostsPostIdRoute
  '/community-hub/spaces/$id/lesson': typeof ProtectedCommunityHubSpacesIdLessonIndexRoute
  '/community-hub/spaces/$id/modules': typeof ProtectedCommunityHubSpacesIdModulesIndexRoute
  '/community-hub/spaces/$id/modules/$moduleId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute
  '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/apps': typeof AppsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/cancel-email-change': typeof AuthCancelEmailChangeRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/magic-link': typeof AuthMagicLinkRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sso': typeof AuthSsoRoute
  '/auth/update-password': typeof AuthUpdatePasswordRoute
  '/auth/verify-email-change': typeof AuthVerifyEmailChangeRoute
  '/orders/$orderNo': typeof OrdersOrderNoRoute
  '/payment-plans/$paymentPlanId': typeof PaymentPlansPaymentPlanIdRoute
  '/subscriptions/$subscriptionNo': typeof SubscriptionsSubscriptionNoRoute
  '/contact/': typeof ContactIndexRoute
  '/_protected/billing/': typeof ProtectedBillingIndexRoute
  '/_protected/community-hub/': typeof ProtectedCommunityHubIndexRoute
  '/_protected/media/': typeof ProtectedMediaIndexRoute
  '/_protected/community-hub/spaces/$id': typeof ProtectedCommunityHubSpacesIdRouteRouteWithChildren
  '/_protected/community-hub/spaces/$id/community': typeof ProtectedCommunityHubSpacesIdCommunityRoute
  '/_protected/community-hub/spaces/$id/': typeof ProtectedCommunityHubSpacesIdIndexRoute
  '/_protected/community-hub/spaces/$id/posts/$postId': typeof ProtectedCommunityHubSpacesIdPostsPostIdRoute
  '/_protected/community-hub/spaces/$id/lesson/': typeof ProtectedCommunityHubSpacesIdLessonIndexRoute
  '/_protected/community-hub/spaces/$id/modules/': typeof ProtectedCommunityHubSpacesIdModulesIndexRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/': typeof ProtectedCommunityHubSpacesIdModulesModuleIdIndexRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdIndexRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEmbedContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdEventContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdFormContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdGcsUploadContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdPdfContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdQuizContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdResultsAttemptIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdTextContentIdRoute
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId': typeof ProtectedCommunityHubSpacesIdModulesModuleIdLessonsLessonIdVideoContentIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/account'
    | '/apps'
    | '/auth/callback'
    | '/auth/cancel-email-change'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/magic-link'
    | '/auth/reset-password'
    | '/auth/sso'
    | '/auth/update-password'
    | '/auth/verify-email-change'
    | '/orders/$orderNo'
    | '/payment-plans/$paymentPlanId'
    | '/subscriptions/$subscriptionNo'
    | '/contact'
    | '/billing'
    | '/community-hub'
    | '/media'
    | '/community-hub/spaces/$id'
    | '/community-hub/spaces/$id/community'
    | '/community-hub/spaces/$id/'
    | '/community-hub/spaces/$id/posts/$postId'
    | '/community-hub/spaces/$id/lesson'
    | '/community-hub/spaces/$id/modules'
    | '/community-hub/spaces/$id/modules/$moduleId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/account'
    | '/apps'
    | '/auth/callback'
    | '/auth/cancel-email-change'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/magic-link'
    | '/auth/reset-password'
    | '/auth/sso'
    | '/auth/update-password'
    | '/auth/verify-email-change'
    | '/orders/$orderNo'
    | '/payment-plans/$paymentPlanId'
    | '/subscriptions/$subscriptionNo'
    | '/contact'
    | '/billing'
    | '/community-hub'
    | '/media'
    | '/community-hub/spaces/$id/community'
    | '/community-hub/spaces/$id'
    | '/community-hub/spaces/$id/posts/$postId'
    | '/community-hub/spaces/$id/lesson'
    | '/community-hub/spaces/$id/modules'
    | '/community-hub/spaces/$id/modules/$moduleId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
    | '/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/account'
    | '/apps'
    | '/auth/callback'
    | '/auth/cancel-email-change'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/magic-link'
    | '/auth/reset-password'
    | '/auth/sso'
    | '/auth/update-password'
    | '/auth/verify-email-change'
    | '/orders/$orderNo'
    | '/payment-plans/$paymentPlanId'
    | '/subscriptions/$subscriptionNo'
    | '/contact/'
    | '/_protected/billing/'
    | '/_protected/community-hub/'
    | '/_protected/media/'
    | '/_protected/community-hub/spaces/$id'
    | '/_protected/community-hub/spaces/$id/community'
    | '/_protected/community-hub/spaces/$id/'
    | '/_protected/community-hub/spaces/$id/posts/$postId'
    | '/_protected/community-hub/spaces/$id/lesson/'
    | '/_protected/community-hub/spaces/$id/modules/'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId'
    | '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  AccountRoute: typeof AccountRoute
  AppsRoute: typeof AppsRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthCancelEmailChangeRoute: typeof AuthCancelEmailChangeRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthMagicLinkRoute: typeof AuthMagicLinkRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSsoRoute: typeof AuthSsoRoute
  AuthUpdatePasswordRoute: typeof AuthUpdatePasswordRoute
  AuthVerifyEmailChangeRoute: typeof AuthVerifyEmailChangeRoute
  OrdersOrderNoRoute: typeof OrdersOrderNoRoute
  PaymentPlansPaymentPlanIdRoute: typeof PaymentPlansPaymentPlanIdRoute
  SubscriptionsSubscriptionNoRoute: typeof SubscriptionsSubscriptionNoRoute
  ContactIndexRoute: typeof ContactIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  AccountRoute: AccountRoute,
  AppsRoute: AppsRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthCancelEmailChangeRoute: AuthCancelEmailChangeRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthMagicLinkRoute: AuthMagicLinkRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSsoRoute: AuthSsoRoute,
  AuthUpdatePasswordRoute: AuthUpdatePasswordRoute,
  AuthVerifyEmailChangeRoute: AuthVerifyEmailChangeRoute,
  OrdersOrderNoRoute: OrdersOrderNoRoute,
  PaymentPlansPaymentPlanIdRoute: PaymentPlansPaymentPlanIdRoute,
  SubscriptionsSubscriptionNoRoute: SubscriptionsSubscriptionNoRoute,
  ContactIndexRoute: ContactIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_protected",
        "/account",
        "/apps",
        "/auth/callback",
        "/auth/cancel-email-change",
        "/auth/forgot-password",
        "/auth/login",
        "/auth/magic-link",
        "/auth/reset-password",
        "/auth/sso",
        "/auth/update-password",
        "/auth/verify-email-change",
        "/orders/$orderNo",
        "/payment-plans/$paymentPlanId",
        "/subscriptions/$subscriptionNo",
        "/contact/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_protected": {
      "filePath": "_protected/route.tsx",
      "children": [
        "/_protected/billing/",
        "/_protected/community-hub/",
        "/_protected/media/",
        "/_protected/community-hub/spaces/$id"
      ]
    },
    "/account": {
      "filePath": "account.tsx"
    },
    "/apps": {
      "filePath": "apps.tsx"
    },
    "/auth/callback": {
      "filePath": "auth/callback.tsx"
    },
    "/auth/cancel-email-change": {
      "filePath": "auth/cancel-email-change.tsx"
    },
    "/auth/forgot-password": {
      "filePath": "auth/forgot-password.tsx"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/auth/magic-link": {
      "filePath": "auth/magic-link.tsx"
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password.tsx"
    },
    "/auth/sso": {
      "filePath": "auth/sso.tsx"
    },
    "/auth/update-password": {
      "filePath": "auth/update-password.tsx"
    },
    "/auth/verify-email-change": {
      "filePath": "auth/verify-email-change.tsx"
    },
    "/orders/$orderNo": {
      "filePath": "orders/$orderNo.tsx"
    },
    "/payment-plans/$paymentPlanId": {
      "filePath": "payment-plans/$paymentPlanId.tsx"
    },
    "/subscriptions/$subscriptionNo": {
      "filePath": "subscriptions/$subscriptionNo.tsx"
    },
    "/contact/": {
      "filePath": "contact/index.tsx"
    },
    "/_protected/billing/": {
      "filePath": "_protected/billing/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/community-hub/": {
      "filePath": "_protected/community-hub/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/media/": {
      "filePath": "_protected/media/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/community-hub/spaces/$id": {
      "filePath": "_protected/community-hub/spaces/$id/route.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/community-hub/spaces/$id/community",
        "/_protected/community-hub/spaces/$id/",
        "/_protected/community-hub/spaces/$id/posts/$postId",
        "/_protected/community-hub/spaces/$id/lesson/",
        "/_protected/community-hub/spaces/$id/modules/",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId",
        "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId"
      ]
    },
    "/_protected/community-hub/spaces/$id/community": {
      "filePath": "_protected/community-hub/spaces/$id/community.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/": {
      "filePath": "_protected/community-hub/spaces/$id/index.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/posts/$postId": {
      "filePath": "_protected/community-hub/spaces/$id/posts/$postId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/lesson/": {
      "filePath": "_protected/community-hub/spaces/$id/lesson/index.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/": {
      "filePath": "_protected/community-hub/spaces/$id/modules/index.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/index.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/index.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/embed/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/event/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/form/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/gcs-upload/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/quiz/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/text/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    },
    "/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId": {
      "filePath": "_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/video/$contentId.tsx",
      "parent": "/_protected/community-hub/spaces/$id"
    }
  }
}
ROUTE_MANIFEST_END */
